
import { useRefreshTrigger } from '~/mixins/gsap'

export default {
  mixins: [useRefreshTrigger],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
